"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Duration = void 0;
var Duration;
(function (Duration) {
    Duration["FOREVER"] = "forever";
    Duration["ONCE"] = "once";
    Duration["REPEATING"] = "repeating";
})(Duration = exports.Duration || (exports.Duration = {}));
